import { Card, CardContent, Grid2 } from '@mui/material'
import Checkbox from 'components/forms/Checkbox'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'

const EntityForm = ({
    entity = {},
    readMode = true,
    setEntity = () => { },
}) => {
    return (
        <Card>
            <CardContent>
                <Grid2 container columnSpacing={2}>
                    <Grid2 container direction={'column'} size={4}>
                        <Grid2>
                            <Input
                                title={i18n.sispeaId}
                                value={entity.idSispea}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, idSispea: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.headquartersDepartment}
                                value={entity.departement}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, departement: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.collectivitySispeaId}
                                value={entity.collectivitySispeaId}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, collectivitySispeaId: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Select
                                label={i18n.collectiviyType}
                                value={entity.id}
                                options={[{ name: entity.type, id: entity.id }]} // change with real options
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, type: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={`N° ${i18n.siren}`}
                                value={entity.numberSiren}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, numberSiren: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={`N° ${i18n.insee}`}
                                value={entity.numberInsee}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, numberInsee: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.municipalitiesMember}
                                value={entity.municipalitiesMember}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, municipalitiesMember: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.EpciMembers}
                                value={entity.epciMembers}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, epciMembers: v }))}
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 container direction={'column'} size={4}>
                        <Grid2>
                            <Input
                                title={i18n.populationOfMunicipalities}
                                value={entity.populationOfMunicipalities}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, populationOfMunicipalities: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.unduplicatedManagementEntityPopulation}
                                value={entity.unduplicatedEntityPopulation}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, unduplicatedEntityPopulation: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.communesServedOnly}
                                value={entity.communesServedOnly}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, communesServedOnly: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Checkbox
                                label={i18n.production}
                                checked={entity.production}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, production: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Checkbox
                                label={i18n.distribution}
                                checked={entity.distribution}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, distribution: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Checkbox
                                label={i18n.transfer}
                                checked={entity.transfer}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, transfer: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Select
                                label={i18n.managementMode}
                                value={entity.id}
                                options={[{ name: entity.managementMode, id: entity.id }]} // change with real options
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, managementMode: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Select
                                label={i18n.operatorStatus}
                                value={entity.id}
                                options={[{ name: entity.operatorStatus, id: entity.id }]} // change with real options
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, operatorStatus: v }))}
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 container columnSpacing={2} direction={'column'} size={4}>
                        <Grid2>
                            <Input
                                title={i18n.operatorEntityName}
                                value={entity.operatorEntityName}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, operatorEntityName: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.contractStartDate}
                                value={entity.contractStartDate}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, contractStartDate: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.contractEndDate}
                                value={entity.contractEndDate}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, contractEndDate: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.nbStructures}
                                value={entity.nbStructures}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, nbStructures: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.delegationPowersAgreement}
                                value={entity.delegationPowersAgreement}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, delegationPowersAgreement: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.startDateDelegationAgreement}
                                value={entity.startDateDelegationAgreement}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, startDateDelegationAgreement: v }))}
                            />
                        </Grid2>
                        <Grid2>
                            <Input
                                title={i18n.endDateDelegationAgreement}
                                value={entity.endDateDelegationAgreement}
                                readMode={readMode}
                                onChange={v => setEntity(prev => ({ ...prev, endDateDelegationAgreement: v }))}
                            />
                        </Grid2>

                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    )
}

EntityForm.propTypes = {
    entity: PropTypes.shape({}),
    readMode: PropTypes.bool,
    nbManagementEntities: PropTypes.number,
    setEntity: PropTypes.func,
}

export default EntityForm
